import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ROUTES } from '@app/routes';
import styles from './Footer.module.css';

export default function Footer() {
  const { t } = useTranslation('nav');
  return (
    <footer className={styles.footer}>
      <div className={styles.inner}>
        <nav className={styles.links}>
          <Link to={ROUTES.contact}>{t('footer.contact')}</Link>
          <span aria-hidden="true">•</span>
          <Link to={ROUTES.termsOfService}>{t('footer.terms')}</Link>
          <span aria-hidden="true">•</span>
          <Link to={ROUTES.privacyPolicy}>{t('footer.privacy')}</Link>
        </nav>
        <p className={styles.credit}>{t('footer.copyright', { year: new Date().getFullYear() })}</p>
      </div>
    </footer>
  );
}
